<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" routerLink="/"></i>

        <span class="my-auto f16 fw-bold me-2"> داشبورد ایاب ذهاب </span>

    </div>

</div>

<div dir="rtl" class="form row gx-2 gy-3 px-2 w-100  py-1">

    <div class="col-12 p-1">

        <div class="col-12 border border-2 rounded">

            <p class="text-center f18 bg-success p-2  text-white"> وضعیت سرویس های امروز </p>

            <canvas id="myChart1" style="max-height: 350px !important;"></canvas>

        </div> 

    </div>

    <div class="col-12 p-1 border border-2 rounded">

        <p class="text-center f18 bg-success p-2 text-white"> سرویس های انجام نشده به تفکیک رانندگان </p>

        <ng-container *ngIf="!list_ServicesNotPerformed.length">

            <p class="text-center"> موردی یافت نشد! </p>

        </ng-container>

        <ng-container *ngIf="list_ServicesNotPerformed.length">

            <table class="table table-striped table-responsive rounded-3 " id="export-excel">

                <thead>
    
                    <tr class="">
    
                        <th class="text-center"> # </th>
    
                        <th class="text-center"> مسیر  </th>
    
                        <th class="text-center pointer"> مبدا  </th>
    
                        <th class="text-center pointer"> مقصد  </th>
    
                        <th class="text-center"> ساعت </th>
    
                        <th class="text-center"> راننده  </th>

                        <th class="text-center"> موبایل  </th>
    
                        <th class="text-center"> نوع خودرو  </th>
    
                    </tr>
    
                </thead>
    
                <tbody>
    
                    <tr class="" *ngFor="let item of list_ServicesNotPerformed; let i=index">
    
                        <td class="text-center"> {{ i + 1 | faNum }} </td>
                        
                        <td class="text-center"> {{ item.strName }} </td>
    
                        <td class="text-center"> {{ item.strSourceStationName }} </td>
    
                        <td class="text-center"> {{ item.strDestinationStationName }} </td>
    
                        <td class="text-center"> {{ item.strSTime | faNum }} </td>
    
                        <td class="text-center"> {{ item.strFullName }} </td>

                        <td class="text-center"> {{ item.strMobile | faNum }} </td>
    
                        <td class="text-center"> {{ item.strMobileType_strComment }} </td>
    
                    </tr>
    
                </tbody>
    
            </table>

        </ng-container>

    </div>

    <div class="col-12 p-1">

        <div class="col-12 border border-2 rounded">

            <p class="text-center f18 bg-success p-2 text-white"> تعداد سرویس به تفکیک راننده در یک ماه آینده </p>

            <canvas id="myChart2" style="max-height: 350px !important;"></canvas>

        </div>

    </div>

    <div class="col-12 p-1">

        <div class="col-12 border border-2 rounded">

            <p class="text-center f18 bg-success p-2 text-white"> تعداد سرویس به تفکیک مسیر در یک ماه آینده </p>

            <canvas id="myChart3" style="max-height: 350px !important;"></canvas>

        </div>

    </div>
    
    <div class="col-12 p-1">

        <div class="col-12 border border-2 rounded">

            <p class="text-center f18 bg-success p-2 text-white"> تعداد ایستگاه به تفکیک مسیر </p>

            <canvas id="myChart4" style="max-height: 350px !important;"></canvas>

        </div>

    </div>

    <div class="col-12 p-1">

        <div class="col-12 border border-2 rounded">

            <p class="text-center f18 bg-success p-2 text-white"> برنامه سرویس ماه آیند </p>

            <div echarts [autoResize]="true" [options]="options | async" id="totalVehicles" class="tree-chart border-bottom"></div>

        </div>

    </div>

</div>